import { FC, useState } from "react";
import { Button } from "@gisce/oficina-virtual-components";
import { AddHomeWork } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import useContractation from "@/components/Contractation/hooks/useContractation";

interface IContractationButtonMenuProps {
  startIcon?: JSX.Element;
  label?: string;
}

const ContractationButtonMenu: FC<IContractationButtonMenuProps> = ({
  startIcon,
  label
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activeContractations } = useContractation();

  // Contractation menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return ( 
    <>
      <Button
        startIcon={startIcon ?? <AddHomeWork />}
        variant="contained"
        onClick={handleClick}
      >
        {label ?? t('common:text.contractation_button_title')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'contractation-menu-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        { activeContractations.types.electricity && 
          pathname !== activeContractations.types.electricity.untranslatedPath && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate(t(activeContractations.types.electricity.untranslatedPath));
            }}
          >
            {t("common:text.contractation_button_title_what", {
              what: t("common:text.electricity")
            })}
          </MenuItem>
        )}
        { activeContractations.types.gas && 
          pathname !== activeContractations.types.gas.untranslatedPath && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate(t(activeContractations.types.gas.untranslatedPath));
            }}
          >
            {t("common:text.contractation_button_title_what", { 
              what: t("common:text.gas") 
            })}
          </MenuItem>
        )}
        { activeContractations.types.dual && 
          pathname !== activeContractations.types.dual.untranslatedPath && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate(t(activeContractations.types.dual.untranslatedPath))
            }}
          >
            {t("common:text.contractation_button_title_what", { 
              what: t("common:text.dual") 
            })}
          </MenuItem>
        )}
      </Menu>
    </>
  );
}

const ContractationButtons: FC<IContractationButtonMenuProps> = ({
  startIcon,
  label
}) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activeContractations } = useContractation();

  return ( activeContractations.num > 1 ?
    <ContractationButtonMenu startIcon={startIcon} label={label}/>
  :
    <>
      { activeContractations.types.electricity.enabled && 
        pathname !== activeContractations.types.electricity.untranslatedPath && (
        <Button
          variant="contained"
          startIcon={startIcon ?? <AddHomeWork />}
          onClick={() => navigate(t(activeContractations.types.electricity.untranslatedPath))}
        >
          {label ?? t("common:text.contractation_button_title_what", { 
            what: t("common:text.electricity")
          })}
        </Button>
      )}
      { activeContractations.types.gas.enabled && 
        pathname !== activeContractations.types.gas.untranslatedPath && (
        <Button
          variant="contained"
          startIcon={startIcon ?? <AddHomeWork />}
          onClick={() => navigate(t(activeContractations.types.gas.untranslatedPath))}
        >
          {label ?? t("common:text.contractation_button_title_what", { 
            what: t("common:text.gas") 
          })}
        </Button>
      )}
      { activeContractations.types.dual.enabled && 
        pathname !== activeContractations.types.dual.untranslatedPath && (
        <Button
          variant="contained"
          startIcon={startIcon ?? <AddHomeWork />}
          onClick={() => navigate(t(activeContractations.types.dual.untranslatedPath))}
        >
          {label ?? t("common:text.contractation_button_title_what", { 
            what: t("common:text.dual") 
          })}
        </Button>
      )}
    </>
  );
}

export {
  ContractationButtonMenu,
  ContractationButtons
};